import React, { useRef, useState, useEffect } from "react";
import PubSub from "pubsub-js";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { useMutation, useLazyQuery } from "@apollo/client";
import { ALL_SURVEY_CATEGORIES, GET_CLIENTS } from "../../GraphQL/Queries";
import {
  CREATE_SURVEY,
  CREATE_CONFIGURATION_SURVEY,
  CREATE_FORM_AS_SURVEY,
} from "../../GraphQL/Mutations";
import {
  setStateSurveyConfiguration,
  initialConfiguration,
} from "../../helpers/StateSurveyConfiguration";
import {
  GeneralStyle,
  FormCard,
  SectionWrapper,
  IntegrationSection,
} from "./SurveyCreationForm.styled";
import { Row, Col } from "react-bootstrap";
import { theme as themeConfig } from "../../themes/themes";
import NotificationManager from "react-notifications/lib/NotificationManager";
import PropTypes from "prop-types";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "react-select";
import { ROLES } from "../../util/RolesConstants";

const SurveyForm = ({
  user,
  setFormTrigger,
  setShowSurveyCreationMain,
  userdata,
  setShowLoader,
  itsForm,
}) => {
  const rSurveyName = useRef();
  const rSurveyDescription = useRef();
  const rSelectedCategory = useRef();
  const rIsTPCL = useRef();
  const [addSurvey] = useMutation(CREATE_SURVEY);
  const [addForm] = useMutation(CREATE_FORM_AS_SURVEY);
  const [createConfigurationSurvey] = useMutation(CREATE_CONFIGURATION_SURVEY);
  const [configuration, setObjectConfiguration] = useState();
  const [surveyId, setSurveyId] = useState([]);
  const [allCategoriesSurvey, setAllCategoriesSurvey] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [selectedValue, setSelectedValue] = useState("No");
  const [selectedClients, setSelectedClients] = useState([]);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const [
    runQueryAllSurveyCategories,
    { error: errorCategories, loading: loadingCategories },
  ] = useLazyQuery(ALL_SURVEY_CATEGORIES, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (selectedValue === "Yes") {
        let allCategoriesSurvey = data.allCategoriesSurvey.outputData
          .filter((f) => f.isGlobal === true)
          .map((c) => ({ ...c }));
        setAllCategoriesSurvey(allCategoriesSurvey);
      } else if (selectedValue === "No") {
        let allCategoriesSurvey = data.allCategoriesSurvey.outputData
          .filter((f) => f.isGlobal === false)
          .map((c) => ({ ...c }));
        setAllCategoriesSurvey(allCategoriesSurvey);
      }
    },
  });

  const [runQueryAllClients] = useLazyQuery(GET_CLIENTS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const clientList = data.clientList.map((c) => ({
        ...{ value: c.clientId, label: c.clientName },
      }));
      setAllClients(clientList);
    },
  });

  useEffect(() => {
    PubSub.subscribe("surveyConfiguration", (e, data) => {
      let record = data.filter((e) => e.field === "TextButtonSave");
      if (record[0]) {
        setObjectConfiguration(record[0]);
      }
    });

    return () => {
      PubSub.unsubscribe("surveyConfiguration");
    };
  }, []);

  useEffect(() => {
    if (configuration) saveSurveyConfiguration();
  }, [configuration]);

  useEffect(() => {
    runQueryAllSurveyCategories().catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
    runQueryAllClients({ context: { clientName: "LinkUsers" } }).catch(
      (error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      }
    );
  }, [setFormTrigger, selectedValue]);

  const saveSurveyConfiguration = () => {
    let clientTpCodes = selectedClients.map((c) => c.value);
    let isGlobal = selectedValue === "Yes" ? true : false;
    let isTemplate = false;
    createConfigurationSurvey({
      variables: {
        idSurvey: surveyId,
        field: configuration?.field,
        jsonConfiguration: JSON.stringify(configuration?.configurationJson),
        createUser: user.userName,
      },
    }).then((response) => {
      setShowSurveyCreationMain({
        idSurvey: surveyId,
        isGlobal: isGlobal,
        isTemplate: isTemplate,
        clientTpCodes: clientTpCodes,
        isIntegrated: rIsTPCL.current.checked,
        isEditSurvey: false,
        dataEditSurvey: null,
        show: true,
      });
    });
  };

  const handleSaveSurvey = () => {
    let surveyName = rSurveyName.current.value;
    let surveyDescription = rSurveyDescription.current.value;
    let surveyCategory = parseInt(rSelectedCategory.current.value);
    let clientTpCodes = selectedClients.map((c) => c.value);
    let isGlobal = selectedValue === "No" ? false : true;
    initialConfiguration([]);
    if (selectedClients.length === 0 && selectedValue === "Yes") {
      NotificationManager.warning(
        "Select a client is required to continue",
        "",
        5000
      );
      return;
    }
    if (!surveyName) {
      NotificationManager.warning(
        "Select a survey name is required to continue",
        "",
        5000
      );
      return;
    }
    if (!surveyDescription) {
      NotificationManager.warning(
        "Select a survey description is required to continue",
        "",
        5000
      );
      return;
    }
    if (!surveyCategory) {
      NotificationManager.warning(
        "Select a survey category is required to continue",
        "",
        5000
      );
      return;
    }
    if (
      surveyName &&
      surveyDescription &&
      surveyCategory > 0 &&
      selectedValue
    ) {
      setShowLoader(true);
      addSurvey({
        variables: {
          surveyName: surveyName,
          surveyDescription: surveyDescription,
          idCategorySurvey: surveyCategory,
          createUser: user.userName,
          countryId: userdata?.currentUser?.location?.countryId,
          isAnonymous: true,
          integrationTpclient: false,
          isGlobal: isGlobal,
          clientTpCodes: clientTpCodes,
        },
      })
        .then((saveResponse) => {
          setStateSurveyConfiguration(surveyName, "surveyName");
          setStateSurveyConfiguration(surveyDescription, "surveyDescription");
          setStateSurveyConfiguration("Send", "TextButtonSave");
          setSurveyId(saveResponse.data.createSurvey);
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    }
  };

  const handleChangeSelectClients = (options) => {
    setSelectedClients(options);
  };

  const handleSaveForm = () => {
    let surveyName = rSurveyName.current.value;
    let surveyDescription = rSurveyDescription.current.value;
    let surveyCategory = parseInt(rSelectedCategory.current.value);
    initialConfiguration([]);
    if (surveyName && surveyDescription && surveyCategory > 0) {
      setShowLoader(true);
      addForm({
        variables: {
          surveyName: surveyName,
          surveyDescription: surveyDescription,
          idCategorySurvey: surveyCategory,
          createUser: user.userName,
          integrationTpclient: true,
          countryId: userdata?.currentUser?.location?.countryId,
        },
      })
        .then((saveResponse) => {
          setStateSurveyConfiguration(surveyName, "surveyName");
          setStateSurveyConfiguration(surveyDescription, "surveyDescription");
          setStateSurveyConfiguration("Send", "TextButtonSave");
          setSurveyId(saveResponse.data.createForm.idSurvey);
          setShowLoader(false);
          NotificationManager.warning(
            `New TpClient case created, ID:${saveResponse.data.createForm.numberCaseTpClient}`,
            "",
            100000
          );
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    }
  };

  let loadCategories = () => {
    if (loadingCategories) return <option key="0">Loading...</option>;
    if (errorCategories) return <option key="0">Error :(</option>;
    if (!loadingCategories && !errorCategories)
      return (
        allCategoriesSurvey &&
        allCategoriesSurvey.length > 0 &&
        allCategoriesSurvey?.map(
          ({ recordState, categoryDescription, idCategorySurvey }) => {
            if (recordState === "Active") {
              return (
                <option key={idCategorySurvey} value={idCategorySurvey}>
                  {categoryDescription}
                </option>
              );
            }
            return null;
          }
        )
      );
  };
  return (
    <>
      <GeneralStyle>
        <FormCard>
          <SectionWrapper>
            {itsForm ? <h1>Create Form</h1> : <h1>Create Survey</h1>}
            <CloseIcon onClick={() => setFormTrigger("")} />
            <hr />
          </SectionWrapper>
          {user.roleId === ROLES.SUPER_ADMIN && (
            <SectionWrapper>
              <Row>
                <Col md="12">
                  <label>Is it a Global Survey?</label>
                  <span style={{ color: themeConfig.status.error }}>*</span>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={"No"}
                        name="radio-buttons-group"
                        className="d-flex"
                        style={{ flexDirection: "row", marginLeft: "0.5em" }}
                        onChange={handleRadioChange}
                      >
                        <FormControlLabel
                          value={"Yes"}
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value={"No"}
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
            </SectionWrapper>
          )}

          <SectionWrapper>
            <Row>
              <Col md="12">
                {itsForm ? (
                  <label>Form Name</label>
                ) : (
                  <label>Survey Name</label>
                )}
                <span style={{ color: themeConfig.status.error }}>*</span>
              </Col>
              <Col md="12">
                <input
                  type="text"
                  ref={rSurveyName}
                  required
                  placeholder="Please enter a name"
                />
              </Col>
            </Row>
          </SectionWrapper>
          <SectionWrapper>
            <Row>
              <Col md="12">
                {itsForm ? (
                  <label>Form Description</label>
                ) : (
                  <label>Survey Description</label>
                )}
                <span style={{ color: themeConfig.status.error }}>*</span>
              </Col>
              <Col md="12">
                <input
                  type="text"
                  ref={rSurveyDescription}
                  required
                  placeholder="Please enter a description"
                />
              </Col>
            </Row>
          </SectionWrapper>

          <SectionWrapper>
            <Row>
              <Col md="12">
                {itsForm ? (
                  <label>Form Category</label>
                ) : (
                  <label>Survey Category</label>
                )}
                <span style={{ color: themeConfig.status.error }}>*</span>
              </Col>
              <Col md="12">
                <select ref={rSelectedCategory}>
                  <option value={0}>--- Select an option ---</option>
                  {loadCategories()}
                </select>
              </Col>
            </Row>
          </SectionWrapper>

          {selectedValue === "Yes" && (
            <SectionWrapper>
              <Row>
                <Col md="12">
                  <label>
                    Select the client{" "}
                    <span style={{ color: themeConfig.status.error }}>*</span>
                  </label>
                </Col>
                <Col md="12">
                  <FormControl component="fieldset" style={{ width: "100%" }}>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isMulti
                      is
                      name="colors"
                      options={allClients}
                      value={selectedClients}
                      onChange={handleChangeSelectClients}
                    />
                  </FormControl>
                </Col>
              </Row>
            </SectionWrapper>
          )}

          <IntegrationSection>
            <input ref={rIsTPCL} type="checkbox" />
            <label>Is integrated with TPClient</label>
          </IntegrationSection>

          {itsForm ? (
            <div className="d-flex justify-content-end">
              <button onClick={() => handleSaveForm()}>Create Form</button>{" "}
            </div>
          ) : (
            <div className="d-flex justify-content-end">
              <button onClick={() => handleSaveSurvey()}>Create Survey</button>
            </div>
          )}
        </FormCard>
      </GeneralStyle>
    </>
  );
};

export default SurveyForm;

SurveyForm.propTypes = {
  user: PropTypes.object,
  setFormTrigger: PropTypes.func,
  setShowSurveyCreationMain: PropTypes.func,
  userdata: PropTypes.object,
  setShowLoader: PropTypes.func,
  itsForm: PropTypes.bool,
};
